import { useEffect } from 'react';
import { useClock } from '@/state/store';
import { useLoader } from './store';

export const ARTEMIS_REPLAY = {
  label: 'Artemis II historical replay',
  startMs: Date.parse('2026-04-01T22:35:12Z'),
  endMs: Date.parse('2026-04-11T00:07:00Z'),
};
export const ARTEMIS_TRAJECTORY_START = Date.parse('2026-04-02T02:00:00Z');
export const ARTEMIS_TRAJECTORY_END = Date.parse('2026-04-10T23:45:00Z');
export const ARTEMIS_FLYBY = Date.parse('2026-04-06T23:01:00Z');

/** Enter once per network change, preserving the user's previous live/simulation clock. */
export function enterArtemisReplay(): () => void {
  const { live, playing, multiplier, simTime, playbackRange } = useClock.getState();
  const { timeframe, sceneMode, orbitPathMode } = useLoader.getState();
  useClock.getState().setPlaybackRange(ARTEMIS_REPLAY);
  useClock.getState().setMultiplier(3600);
  useLoader.setState({
    sceneMode: '3D',
    orbitPathMode: 'selected',
    timeframe: {
      ...timeframe,
      startMs: ARTEMIS_REPLAY.startMs,
      endMs: ARTEMIS_REPLAY.endMs,
      hours: (ARTEMIS_REPLAY.endMs - ARTEMIS_REPLAY.startMs) / 3_600_000,
      fiscalYear: 2026,
    },
  });
  return () => {
    useClock.setState({ live, playing, multiplier, simTime: live ? Date.now() : simTime, playbackRange });
    // setNetwork has already chosen the next constellation's defaults.
    // Only restore the old camera/path choice when leaving replay in-place.
    useLoader.setState({ timeframe, ...(useLoader.getState().network === 'artemis' ? { sceneMode, orbitPathMode } : {}) });
  };
}

export function useMissionReplay(): void {
  const network = useLoader((s) => s.network);
  useEffect(() => {
    if (network === 'artemis') return enterArtemisReplay();
  }, [network]);
}
